export default props => (
<div class="slds-page-header slds-page-header_record-home">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-icon_container slds-icon-standard-opportunity">
                  <svg class="slds-icon slds-icon_inverse slds-icon_medium" aria-hidden="true">
                    <use xlinkHref="/icons/standard-sprite/svg/symbols.svg#opportunity"></use>
                  </svg>
              </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span>Opportunity</span>
                <span class="slds-page-header__title slds-truncate" title="Acme - 1,200 Widgets">Acme - 1,200 Widgets</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
        <button class="slds-button slds-button_stateful slds-button_neutral slds-not-selected" aria-live="polite" part="button">
            <span class="slds-text-not-selected">
                <svg class="slds-button__icon_stateful slds-button__icon_left" focusable="false" data-key="add" aria-hidden="true" viewBox="0 0 520 520" part="icon"><g><path d="M300 290h165c8 0 15-7 15-15v-30c0-8-7-15-15-15H300c-6 0-10-4-10-10V55c0-8-7-15-15-15h-30c-8 0-15 7-15 15v165c0 6-4 10-10 10H55c-8 0-15 7-15 15v30c0 8 7 15 15 15h165c6 0 10 4 10 10v165c0 8 7 15 15 15h30c8 0 15-7 15-15V300c0-6 4-10 10-10z"></path></g></svg>
                Follow
            </span>
            <span class="slds-text-selected">
                <svg class="slds-button__icon_stateful slds-button__icon_left" focusable="false" data-key="check" aria-hidden="true" viewBox="0 0 520 520" part="icon"><g><path d="M191 425L26 259c-6-6-6-16 0-22l22-22c6-6 16-6 22 0l124 125a10 10 0 0015 0L452 95c6-6 16-6 22 0l22 22c6 6 6 16 0 22L213 425c-6 7-16 7-22 0z"></path></g></svg>
                Following
            </span>
            <span class="slds-text-selected-focus">
                <svg class="slds-button__icon_stateful slds-button__icon_left" focusable="false" data-key="close" aria-hidden="true" viewBox="0 0 520 520" part="icon"><g><path d="M310 254l130-131c6-6 6-15 0-21l-20-21c-6-6-15-6-21 0L268 212a10 10 0 01-14 0L123 80c-6-6-15-6-21 0l-21 21c-6 6-6 15 0 21l131 131c4 4 4 10 0 14L80 399c-6 6-6 15 0 21l21 21c6 6 15 6 21 0l131-131a10 10 0 0114 0l131 131c6 6 15 6 21 0l21-21c6-6 6-15 0-21L310 268a10 10 0 010-14z"></path></g></svg>
                Unfollow
            </span>
        </button>
        </div>
        <div class="slds-page-header__control">
          <ul class="slds-button-group-list">
            <li>
                <button class="slds-button slds-button_neutral" aria-disabled="false" type="button" part="button" kx-scope="button-neutral" kx-type="ripple">Edit</button>
            </li>
            <li>
                <button class="slds-button slds-button_neutral" aria-disabled="false" type="button" part="button" kx-scope="button-neutral" kx-type="ripple">Delete</button>
            </li>
            <li>
                <button class="slds-button slds-button_neutral" aria-disabled="false" type="button" part="button" kx-scope="button-neutral" kx-type="ripple">Clone</button>
            </li>
            <li>
                <button class="slds-button slds-button_icon-border-filled" aria-expanded="false" value="" aria-haspopup="true" type="button" part="button button-icon"><lightning-primitive-icon variant="bare"><svg class="slds-button__icon" focusable="false" data-key="down" aria-hidden="true" viewBox="0 0 520 520" part="icon"><g><path d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"></path></g></svg></lightning-primitive-icon><span class="slds-assistive-text">Show menu</span></button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="slds-page-header__row slds-page-header__row_gutters">
    <div class="slds-page-header__col-details">
      <ul class="slds-page-header__detail-row">
        <li class="slds-page-header__detail-block">
          <div class="slds-text-title slds-truncate" title="Field 1">Field 1</div>
          <div class="slds-truncate" title="Description that demonstrates truncation with a long text field.">Description that demonstrates truncation with a long text field.</div>
        </li>
        <li class="slds-page-header__detail-block">
          <div class="slds-text-title slds-truncate" title="Field 2 (3)">Field 2 (3)</div>
          <div class="slds-truncate" title="Multiple Values">Multiple Values</div>
        </li>
        <li class="slds-page-header__detail-block">
          <div class="slds-text-title slds-truncate" title="Field 3">Field 3</div>
          <div class="slds-truncate" title="Hyperlink">
            <a href="#">Hyperlink</a>
          </div>
        </li>
        <li class="slds-page-header__detail-block">
          <div class="slds-text-title slds-truncate" title="Field 4">Field 4</div>
          <div class="slds-truncate" title="Description (2-line truncation—must use JS to truncate).">Description (2-line truncati...</div>
        </li>
      </ul>
    </div>
  </div>
</div>
)